<template>
        <div class="scroll_bar" :style="`transform: scaleY(${this.scale});`"></div>
</template>

<script>
import Store from '@/stores/store.js'

export default {
    name: 'ScrollBar',

    data() {
        return {
            isEnabled : false,
            scale : 0,
            state : Store.state,
            timeout : null,
        }
    },

    created(){
    },

    methods: {
        updateScale() {
            this.scale = Store.state.scrollRatio
        },
    },
    watch: {
        'state.scrollRatio': function () {
            this.updateScale()
            
        }
    }
}
</script>


<style scoped lang="scss">
    .scroll_bar {
        position: absolute;
        background: #808080;
        height: 100vh;
        width: 5px;
        mix-blend-mode: difference;
        right: 0;
        transform: scaleY(0);
        transform-origin: top;
    }
    .isTouch {
        .scroll_bar {
            display: none;
        }
    }
</style>
